/* eslint-disable react/require-default-props */
import React from 'react';
import Checkbox from 'components/atoms/checkbox';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ManagementState } from 'store/modules/management_store/types';

interface TaskFilterProps {
  filterLate: boolean;
  setFilterLate: React.Dispatch<React.SetStateAction<boolean>>;
  filterToday: boolean;
  setFilterToday: React.Dispatch<React.SetStateAction<boolean>>;
  filterFuture: boolean;
  setFilterFuture: React.Dispatch<React.SetStateAction<boolean>>;
  filterFinished: boolean;
  setFilterFinished: React.Dispatch<React.SetStateAction<boolean>>;
  source?: string;
  biddingId?: number | null;
}

const TaskFilter = (props: TaskFilterProps) => {
  const {
    filterLate,
    setFilterLate,
    filterToday,
    setFilterToday,
    filterFuture,
    setFilterFuture,
    filterFinished,
    setFilterFinished,
    source = 'management',
    biddingId = null,
  } = props;

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const taskCounter = (taskType: 'late' | 'today' | 'future' | 'finished') => {
    if (source === 'management') {
      return management.management_summary.total_tasks[taskType] || 0;
    }

    if (biddingId)
      return management?.bidding_summary[biddingId?.toString()]?.total_tasks[taskType] || 0;

    return 0;
  };

  return (
    <div className="d-md-flex d-block align-items-center">
      <Checkbox
        customClass="checkbox-danger mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterLate(!filterLate)}
        label={`Atrasadas(${taskCounter('late')})`}
        checked={filterLate}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-warning mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterToday(!filterToday)}
        label={`Hoje(${taskCounter('today')})`}
        checked={filterToday}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-info mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterFuture(!filterFuture)}
        label={`Futuras(${taskCounter('future')})`}
        checked={filterFuture}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-success mr-4 mb-2 mb-md-0"
        handleChange={() => setFilterFinished(!filterFinished)}
        label={`Concluídas(${taskCounter('finished')})`}
        checked={filterFinished}
        disabled={false}
      />
    </div>
  );
};

export default TaskFilter;
